import {createCustomerOfferRevision} from "@project/sdk/sales";
import {CreateCustomerOfferRevisionResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";

export function createCustomerOfferRevisionMutationOptions() {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.createCustomerOfferRevision,
    mutationFn: async (id: string) =>
      CreateCustomerOfferRevisionResponse.parse(await createCustomerOfferRevision(id)),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await client.invalidateQueries({queryKey: customerOfferKeys.lists()});
    },
  });
}
